// extracted by mini-css-extract-plugin
export default {"wordBreak":"MpcExpandRow_wordBreak__Zs4UJ"};